<div id="aboutMe_link" class="target-element"></div>
<div class="aboutMe_container">
    <img src="./../../../assets/ellipse.png" class="ellipse_1">
    <img src="./../../../assets/ellipse.png" class="ellipse_2">

    <div class="content">

        <div class="left_side">
            <div class="leftSide_mainPart">
                <h1 id="work_together">Lasst uns gemeinsam arbeiten</h1>
                <h2 id="i_am">Ich bin</h2>
                <div class="shortCutsContainer">
                    <div>
                        <div>
                            <div class="shortCutsImages" id="locationShortcut">
                                <img src="./../../../assets/about_me/location.png" id="location_img">
                                <img src="./../../../assets/about_me/location_hover.png" id="location_hover_img"
                                    class="display-none">
                            </div>
                            <span id="locatedIn">wohnhaft in <br> Stuttgart</span>
                        </div>
                    </div>

                    <div>
                        <div>
                            <div class="shortCutsImages" id="remoteShortcut">
                                <img src="./../../../assets/about_me/remote.png" id="remote_img">
                                <img src="./../../../assets/about_me/remote_hover.png" id="remote_hover_img"
                                    class="display-none">
                            </div>
                            <span id="remoteWork">Bereit remote <br> zu arbeiten</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       
            <div class="right_side">
                <div>
                    <p id="about_me_main" class="hideBR">
                        Ich bin Frontend Developer und wohnhaft in Stuttgart.<br>
                        Mit meinen Kenntnissen bin ich in der Lage, Ideen von Designern und Unternehmen in echte
                        Projekte umzusetzen. <br>
                        Daher würde ich gerne eine Stelle als Junior Web Developer aufnehmen. <br>
                        Meine Fähigkeiten komplexe Probleme zu lösen <br>
                        als auch meine Leidenschaft für das Programmieren <br>
                        würden mich zu einem wertvollen Mitglied in Ihrem Team machen.
                    </p>
                    <p id="contact_if_match">
                        Kontaktieren Sie mich, für ein persönliches Gespräch. 
                    </p>
                    <div id="contact_me_BtnContainer">
                        <a (click)="webpageComponent.goToContact()">
                            <button class="button" id="sendMessage">Kontaktieren</button>
                        </a>
                    </div>
                </div>

            </div>


    </div>


</div>